import type { Locale } from '@seek/melways-sites';
import { Stack } from 'braid-design-system';

// FIXME : Define types for Attachment and Note instead of using from hirer-types.generated
import type {
  ApplicationAttachmentType,
  ApplicationNoteV2,
} from 'src/App/AppPageBlock/graphql/hirer-types.generated';
import type { TrackStatusUpdateAttributes } from 'src/utils/eventsTypes';

import { AttachmentItem } from '../AttachmentItem/AttachmentItem';
import { NoteItem } from '../NotesItem/NoteItem';

export interface Attachment {
  attachmentType: ApplicationAttachmentType;
  attachmentId: string;
  fileName?: string | null;
  hasConvertedPdf: boolean;
  uploadedDate?: string | null;
  uploadedUser?: string | null;
  __typename: 'ApplicationAttachmentV2';
}

interface Note {
  content: string;
  createdDate: string | any;
  createdUserId: string;
  id: string;
  createdUserLastname: string;
  createdUserFirstname: string;
  __typename: 'ApplicationNoteV2';
}
interface Props {
  sortedNotesAttachments: Array<Attachment | Note>;
  locale: Locale;
  isVerifiedId: TrackStatusUpdateAttributes['isVerifiedId'];
  jobId: string;
  applicationCorrelationId: string;
  onDeleteNote: (noteItem: ApplicationNoteV2) => Promise<'done' | 'error'>;
  onDeleteAttachment: (attachmentItem: Attachment) => Promise<'done' | 'error'>;
  userId: string;
  jobApplicationId: string;
  seekCandidateId: string;
  candidateId: string;
}
export const NotesAttachmentList = ({
  sortedNotesAttachments,
  locale,
  isVerifiedId,
  jobId,
  applicationCorrelationId,
  onDeleteNote,
  onDeleteAttachment,
  userId,
  jobApplicationId,
  seekCandidateId,
  candidateId,
}: Props) => (
  <Stack space="small">
    {sortedNotesAttachments.map((attachmentOrNote) => {
      if (attachmentOrNote.__typename === 'ApplicationAttachmentV2') {
        return (
          <AttachmentItem
            key={attachmentOrNote.attachmentId}
            attachmentItem={attachmentOrNote}
            locale={locale}
            isVerifiedId={isVerifiedId}
            jobId={jobId}
            applicationCorrelationId={applicationCorrelationId}
            onDelete={onDeleteAttachment}
            jobApplicationId={jobApplicationId}
            seekCandidateId={seekCandidateId}
            candidateId={candidateId}
          />
        );
      }

      return (
        <NoteItem
          key={attachmentOrNote.id}
          noteItem={attachmentOrNote}
          locale={locale}
          onDelete={onDeleteNote}
          canDelete={userId === attachmentOrNote.createdUserId}
        />
      );
    })}
  </Stack>
);
